exports.install = function (Vue, options) {
  Vue.prototype.testString = function (val){//全局函数1
    
  };
  Vue.prototype.text2 = function (){//全局函数2
    alert('执行成功2');
  };
};



// WEBPACK FOOTER //
// ./src/assets/base.js